// emailService.js
import emailjs from '@emailjs/browser';

const sanitize = (value) => {
  if (typeof value === 'string') {
    return value.trim() === '' ? 'N/A' : value;
  }
  if (value === undefined || value === null) {
    return 'N/A';
  }
  return value;
};


const SERVICE_ID = 'service_xfj5l6s';
const ADMIN_TEMPLATE_ID = 'template_fa7qndd';
const USER_TEMPLATE_ID = 'template_vghzjt8';

// SubService template IDs
const SUBSERVICE_ADMIN_TEMPLATE_ID = 'template_mo5pzwu';
const SUBSERVICE_USER_TEMPLATE_ID = 'template_bz16ror';

// Motor vehicle accident form

const MotorVehicle_ADMIN_TEMPLATE_ID = 'template_rtu70jb'
const MotorVehicle_USER_TEMPLATE_ID = 'template_xfveyie'

// Talcum Powder form
const TalcumPowder_ADMIN_TEMPLATE_ID = 'template_kvmmyig'
const TalcumPowder_USER_TEMPLATE_ID = 'template_5if400h'

// Depo Provera form
const DepoProvera_ADMIN_TEMPLATE_ID = 'template_vf1p4wh'
const DepoProvera_USER_TEMPLATE_ID = 'template_wnvmf8b'

//Hair Relaxer form
const HairRelaxer_ADMIN_TEMPLATE_ID = 'template_lezimdw'
const HairRelaxer_USER_TEMPLATE_ID = 'template_tmeg83l'

// Ozempic form
const Ozempic_ADMIN_TEMPLATE_ID = 'template_raogh7n'
const Ozempic_USER_TEMPLATE_ID = 'template_z0riks6'

// Hernia Mesh form
const HerniaMesh_ADMIN_TEMPLATE_ID = 'template_lzgibf4'
const HerniaMesh_USER_TEMPLATE_ID = 'template_vbarzc9'

//depolawsuitlanderA
const DepoProveraLawsuit_ADMIN_TEMPLATE_ID = 'template_13gtjyh';
const DepoProveraLawsuit_USER_TEMPLATE_ID = 'template_5gi0ecl';

//hairrelaxerlawsuitlanderA
const HairRelaxerLawsuit_ADMIN_TEMPLATE_ID = 'template_0ujekgm'; 
const HairRelaxerLawsuit_USER_TEMPLATE_ID = 'template_h87vmka';

//herniameshlawsuitlanderA
const HerniaMeshLawsuit_ADMIN_TEMPLATE_ID = 'template_7t503xr';
const HerniaMeshLawsuit_USER_TEMPLATE_ID = 'template_4eiwwsx';

//ozempiclawsuitlanderAtemplate_vers05g
const OzempicLawsuit_ADMIN_TEMPLATE_ID = 'template_52dbnfp';
const OzempicLawsuitE_ADMIN_TEMPLATE_ID = 'template_q6b31ck';

const OzempicLawsuit_USER_TEMPLATE_ID = 'template_nsclmwn';

//talcumlawsuitlanderA
const TalcumPowderLawsuit_ADMIN_TEMPLATE_ID = 'template_j70byii';
const TalcumPowderLawsuit_USER_TEMPLATE_ID = 'template_qyy1y0s';

//ridesharesalanderA
const RideshareSALawsuit_ADMIN_TEMPLATE_ID = 'template_y1xps56';
const RideshareSALawsuit_USER_TEMPLATE_ID = 'template_9d4lgsv';

//robloxsalanderA
const RobloxSALawsuit_ADMIN_TEMPLATE_ID = 'template_9nb0m4g';
const RobloxSALawsuit_USER_TEMPLATE_ID = 'template_z6gfwqr';

//socialmediaAddictionlanderA
const SMALawsuit_ADMIN_TEMPLATE_ID= 'template_g1u0iv7';
const SMALawsuit_USER_TEMPLATE_ID= 'template_5kcr7db';

//rounduplawsuitlanderA
const ROUNDUP_LAWSUIT_ADMIN_TEMPLATE_ID = 'template_m4v7d3o';
const ROUNDUP_LAWSUIT_USER_TEMPLATE_ID = 'template_ivhbson';

// Dupixent lawsuit lander D
const DupixentLawsuit_ADMIN_TEMPLATE_ID = 'template_1ztlfca';
const DupixentLawsuit_USER_TEMPLATE_ID = 'template_2b9973t';

const PUBLIC_KEY = 'LHN36zibZMdIZeRb7';
const getCentralTime = () => {
  return new Date().toLocaleString("en-US", {
    timeZone: "America/Chicago",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  });
};
emailjs.init(PUBLIC_KEY);

// Function to get the initial landing URL
let initialLandingUrl = null;

const getSourceUrl = () => {
  if (typeof window === "undefined") return "Unknown";

  // If we haven't stored the initial URL yet, store it
  if (!initialLandingUrl) {
    initialLandingUrl = window.location.href;
  }

  return initialLandingUrl;
};

// Function to get IP address
const getIPAddress = async () => {
  try {
    const response = await fetch("https://api.ipify.org?format=json");
    const data = await response.json();
    return data.ip;
  } catch (error) {
    console.error("Failed to get IP address:", error);
    return "IP address not available";
  }
};
// Function to get CST timestamp
const getCSTTimestamp = () => {
  return new Date().toLocaleString("en-US", {
    timeZone: "America/Chicago",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  });
};
// Function to clean phone number to 10 digits
const cleanPhoneNumber = (phone) => {
  if (!phone) return '';
  // Remove all non-digit characters
  const digits = phone.replace(/\D/g, '');
  // Return last 10 digits if more than 10, otherwise return all digits
  return digits.length > 10 ? digits.slice(-10) : digits;
};

// Original functions (keeping your existing ones)
export const sendAdminEmail = async (formData) => {
  const ipAddress = await getIPAddress();

  const templateParams = {
    name: formData.name,
    email: formData.email,
    phone: formData.phone,
    alternateNumber: sanitize(formData.alternateNumber),
    category: formData.category,
    streetAddress: formData.streetAddress,
    city: formData.city,
    state: formData.state,
    zipCode: formData.zipCode,
    fullAddress: `${formData.streetAddress}, ${formData.city}, ${formData.state} ${formData.zipCode}`,
    message: `New legal service request from ${formData.name}`,
    submissionDate: new Date().toLocaleString(),
submissionDateCST: getCSTTimestamp(),
    ip_address: ipAddress,
    page_source: getSourceUrl(),

    // TrustedForm data
    trustedFormCertUrl: formData.xxTrustedFormCertUrl || 'Not available',
    trustedFormPingUrl: formData.xxTrustedFormPingUrl || 'Not available',
    trustedFormToken: formData.xxTrustedFormCertToken || 'Not available',
  };

  return emailjs.send(SERVICE_ID, ADMIN_TEMPLATE_ID, templateParams);
};

export const sendUserEmail = async (formData) => {
  const ipAddress = await getIPAddress();

  const templateParams = {
    name: formData.name,
    email: formData.email,
    phone: formData.phone,
    alternateNumber: sanitize(formData.alternateNumber),
    category: formData.category,
    streetAddress: formData.streetAddress,
    city: formData.city,
    state: formData.state,
    zipCode: formData.zipCode,
    fullAddress: `${formData.streetAddress}, ${formData.city}, ${formData.state} ${formData.zipCode}`,
    date: new Date().toLocaleDateString(),
    ip_address: ipAddress,
    submissionDate: new Date().toLocaleString(),
submissionDateCST: getCSTTimestamp(),
    page_source: getSourceUrl(),

    // TrustedForm data
    trustedFormCertUrl: formData.xxTrustedFormCertUrl || 'Not available',
    trustedFormPingUrl: formData.xxTrustedFormPingUrl || 'Not available',
    trustedFormToken: formData.xxTrustedFormCertToken || 'Not available',
  };

  return emailjs.send(SERVICE_ID, USER_TEMPLATE_ID, templateParams);
};

// NEW SubService functions
export const SubServiceSendAdminEmail = async (formData) => {
  const ipAddress = await getIPAddress();

  const templateParams = {
    // Handle both desktop and mobile form field names
    firstName: formData.firstName || formData.fist_name || '',
    lastName: formData.lastName || '',
    full_name: `${formData.firstName || formData.fist_name || ''} ${formData.lastName || ''}`.trim(),
    email: formData.email,
    phone: formData.phone,
    alternateNumber: sanitize(formData.alternateNumber),
    streetAddress: formData.streetAddress,
    city: formData.city,
    state: formData.state,
    zipCode: formData.zipCode,
    fullAddress: `${formData.streetAddress || ''}, ${formData.city || ''}, ${formData.state || ''} ${formData.zipCode || ''}`.replace(/^,\s*/, '').trim(),
    message: `New SubService case review request from ${formData.firstName || formData.fist_name || ''} ${formData.lastName || ''}`,
    submissionDate: new Date().toLocaleString(),
submissionDateCST: getCSTTimestamp(),
    ip_address: ipAddress,
    page_source: getSourceUrl(),

    // TrustedForm data
    trustedFormCertUrl: formData.xxTrustedFormCertUrl || 'Not available',
    trustedFormPingUrl: formData.xxTrustedFormPingUrl || 'Not available',
    trustedFormToken: formData.xxTrustedFormCertToken || 'Not available',

    // Additional fields for better tracking
    form_type: 'SubService Case Review',
    captcha_verified: 'Yes',
    terms_accepted: formData.termsAccepted ? 'Yes' : 'No',
  };

  return emailjs.send(SERVICE_ID, SUBSERVICE_ADMIN_TEMPLATE_ID, templateParams);
};

export const SubServiceSendUserEmail = async (formData) => {
  const ipAddress = await getIPAddress();

  const templateParams = {
    // Handle both desktop and mobile form field names
    firstName: formData.firstName || formData.firstName || '',
    lastName: formData.lastName || '',
    full_name: `${formData.firstName || formData.firstName || ''} ${formData.lastName || ''}`.trim(),
    email: formData.email,
    alternateNumber: sanitize(formData.alternateNumber),

    phone: formData.phone,
    streetAddress: formData.streetAddress,
    city: formData.city,
    state: formData.state,
    zipCode: formData.zipCode,
    fullAddress: `${formData.streetAddress || ''}, ${formData.city || ''}, ${formData.state || ''} ${formData.zipCode || ''}`.replace(/^,\s*/, '').trim(),
    date: new Date().toLocaleDateString(),
    submissionDate: new Date().toLocaleString(),
submissionDateCST: getCSTTimestamp(),
    ip_address: ipAddress,
    page_source: getSourceUrl(),

    // TrustedForm data
    trustedFormCertUrl: formData.xxTrustedFormCertUrl || 'Not available',
    trustedFormPingUrl: formData.xxTrustedFormPingUrl || 'Not available',
    trustedFormToken: formData.xxTrustedFormCertToken || 'Not available',

    // Additional fields for personalization
    form_type: 'SubService Case Review',
  };

  return emailjs.send(SERVICE_ID, SUBSERVICE_USER_TEMPLATE_ID, templateParams);
};


export const MotorVehicleSendAdminEmail = async ({formData}) => {
  const ipAddress = await getIPAddress();

  const templateParams = {
    
    submissionDate: new Date().toLocaleString(),
submissionDateCST: getCSTTimestamp(),
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    
    FirstName: formData.FirstName,
    LastName: formData.LastName,
    email: formData.email,
    phoneNumber: formData.phoneNumber,
    q1: formData['Were you injured in a motor vehicle accident, or are you looking to file a claim?'],
    q2: formData['Do you currently have a motor vehicle accident claim, or are you looking to file one?'],
    trustedFormCertUrl: formData.certId,
    trustedFormPingUrl: formData.pingUrl,
    trustedFormToken: formData.tokenUrl,
    ip_address: ipAddress,
    page_source: getSourceUrl()
  };

  return emailjs.send(SERVICE_ID, MotorVehicle_ADMIN_TEMPLATE_ID, templateParams);
};


export const MotorVehicleSendUserEmail = async ({formData}) => {
  const templateParams = {
    
    submissionDate: new Date().toLocaleString(),
submissionDateCST: getCSTTimestamp(),
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,

    FirstName: formData.FirstName,
    LastName: formData.LastName,
    email: formData.email,
    phoneNumber: formData.phoneNumber,
    q1: formData['Were you injured in a motor vehicle accident, or are you looking to file a claim?'],
    q2: formData['Do you currently have a motor vehicle accident claim, or are you looking to file one?'],
  };

  return emailjs.send(SERVICE_ID, MotorVehicle_USER_TEMPLATE_ID, templateParams);
};

















//depo lawsuit lander form functions A
export const DepoProveraLawsuitSendAdminEmail = async ({ formData }) => {
  const ipAddress = await getIPAddress();

  const templateParams = {
    submissionDate: new Date().toLocaleString(),
submissionDateCST: getCSTTimestamp(),
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,

    fullName: sanitize(formData.fullName),
    email: sanitize(formData.email),
    phone: sanitize(formData.phone),

    // 3-question lawsuit lander questions
    q1: sanitize(formData.q1), // "Have you been diagnosed with meningioma?"
    q2: sanitize(formData.q2), // "Have you ever used Depo-Provera or Depo-SubQ Provera?"
    q3: sanitize(formData.q3), // "Are you currently working with an attorney regarding this matter?"

    message: `New Depo-Provera Lawsuit inquiry from ${sanitize(formData.fullName)}`,

    certId: sanitize(formData.certId),
    pingUrl: sanitize(formData.pingUrl),
    tokenUrl: sanitize(formData.tokenUrl),

    ip_address: ipAddress,
    page_source: getSourceUrl(),
    form_type: 'Depo-Provera Lawsuit Landing Page',

    // Ad tracking
    gclid: sanitize(formData.gclid),
    gbraid: sanitize(formData.gbraid),
    wbraid: sanitize(formData.wbraid),
  };

  return emailjs.send(SERVICE_ID, DepoProveraLawsuit_ADMIN_TEMPLATE_ID, templateParams);
};

export const DepoProveraLawsuitSendUserEmail = async ({ formData }) => {
  const templateParams = {
    submissionDate: new Date().toLocaleString(),
submissionDateCST: getCSTTimestamp(),
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,

    fullName: sanitize(formData.fullName),
    email: sanitize(formData.email),
    phone: sanitize(formData.phone),

    // Include questions for confirmation
    q1: sanitize(formData.q1),
    q2: sanitize(formData.q2),
    q3: sanitize(formData.q3),

    date: new Date().toLocaleDateString(),
    form_type: 'Depo-Provera Lawsuit Landing Page'
  };

  return emailjs.send(SERVICE_ID, DepoProveraLawsuit_USER_TEMPLATE_ID, templateParams);
};

//hair relaxer lander form functions A
export const HairRelaxerLawsuitSendAdminEmail = async ({ formData }) => {
  const ipAddress = await getIPAddress();

  const templateParams = {
    submissionDate: new Date().toLocaleString(),
submissionDateCST: getCSTTimestamp(),
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,

    fullName: sanitize(formData.fullName),
    email: sanitize(formData.email),
    phone: sanitize(formData.phone),

    // 3-question lawsuit lander questions
    q1: sanitize(formData.q1), // "Have you been diagnosed with any of the following?"
    q2: sanitize(formData.q2), // "Have you used chemical hair relaxer products?"
    q3: sanitize(formData.q3), // "Are you currently working with an attorney regarding this matter?"

    message: `New Hair Relaxer Lawsuit inquiry from ${sanitize(formData.fullName)}`,

    certId: sanitize(formData.certId),
    pingUrl: sanitize(formData.pingUrl),
    tokenUrl: sanitize(formData.tokenUrl),

    ip_address: ipAddress,
    page_source: getSourceUrl(),
    form_type: 'Hair Relaxer Lawsuit Landing Page',

    // Ad tracking
    gclid: sanitize(formData.gclid),
    gbraid: sanitize(formData.gbraid),
    wbraid: sanitize(formData.wbraid),
  };

  return emailjs.send(SERVICE_ID, HairRelaxerLawsuit_ADMIN_TEMPLATE_ID, templateParams);
};

export const HairRelaxerLawsuitSendUserEmail = async ({ formData }) => {
  const templateParams = {
    submissionDate: new Date().toLocaleString(),
submissionDateCST: getCSTTimestamp(),
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,

    fullName: sanitize(formData.fullName),
    email: sanitize(formData.email),
    phone: sanitize(formData.phone),

    // Include questions for confirmation
    q1: sanitize(formData.q1),
    q2: sanitize(formData.q2),
    q3: sanitize(formData.q3),

    date: new Date().toLocaleDateString(),
    form_type: 'Hair Relaxer Lawsuit Landing Page'
  };

  return emailjs.send(SERVICE_ID, HairRelaxerLawsuit_USER_TEMPLATE_ID, templateParams);
};

//herniamesh lander form functions A
export const HerniaMeshLawsuitSendAdminEmail = async ({ formData }) => {
  const ipAddress = await getIPAddress();

  const templateParams = {
    submissionDate: new Date().toLocaleString(),
submissionDateCST: getCSTTimestamp(),
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,

    fullName: sanitize(formData.fullName),
    email: sanitize(formData.email),
    phone: sanitize(formData.phone),

    // 3-question lawsuit lander questions
    q1: sanitize(formData.q1), // "Did you undergo hernia repair surgery involving a mesh implant?"
    q2: sanitize(formData.q2), // "Did you experience complications after the surgery?"
    q3: sanitize(formData.q3), // "Are you currently working with an attorney regarding this matter?"

    message: `New Hernia Mesh Lawsuit inquiry from ${sanitize(formData.fullName)}`,

    certId: sanitize(formData.certId),
    pingUrl: sanitize(formData.pingUrl),
    tokenUrl: sanitize(formData.tokenUrl),

    ip_address: ipAddress,
    page_source: getSourceUrl(),
    form_type: 'Hernia Mesh Lawsuit Landing Page',

    // Ad tracking
    gclid: sanitize(formData.gclid),
    gbraid: sanitize(formData.gbraid),
    wbraid: sanitize(formData.wbraid),
  };

  return emailjs.send(SERVICE_ID, HerniaMeshLawsuit_ADMIN_TEMPLATE_ID, templateParams);
};

export const HerniaMeshLawsuitSendUserEmail = async ({ formData }) => {
  const templateParams = {
    submissionDate: new Date().toLocaleString(),
submissionDateCST: getCSTTimestamp(),
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,

    fullName: sanitize(formData.fullName),
    email: sanitize(formData.email),
    phone: sanitize(formData.phone),

    // Include questions for confirmation
    q1: sanitize(formData.q1),
    q2: sanitize(formData.q2),
    q3: sanitize(formData.q3),

    date: new Date().toLocaleDateString(),
    form_type: 'Hernia Mesh Lawsuit Landing Page'
  };

  return emailjs.send(SERVICE_ID, HerniaMeshLawsuit_USER_TEMPLATE_ID, templateParams);
};

//ozempic lander form functions A
export const OzempicLawsuitSendAdminEmail = async ({ formData }) => {
  const ipAddress = await getIPAddress();

  const templateParams = {
    submissionDate: new Date().toLocaleString(),
submissionDateCST: getCSTTimestamp(),
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,

    fullName: sanitize(formData.fullName),
    email: sanitize(formData.email),
    phone: sanitize(formData.phone),

    // 3-question lawsuit lander questions
    q1: sanitize(formData.q1), // "Have you been diagnosed with NAION?"
    q2: sanitize(formData.q2), // "Have you taken GLP-1 medications?"
    q3: sanitize(formData.q3), // "Are you currently working with an attorney?"

    message: `New Ozempic Lawsuit inquiry from ${sanitize(formData.fullName)}`,

    certId: sanitize(formData.certId),
    pingUrl: sanitize(formData.pingUrl),
    tokenUrl: sanitize(formData.tokenUrl),

    ip_address: ipAddress,
    page_source: getSourceUrl(),
    form_type: 'Ozempic Lawsuit Landing Page',

    // Ad tracking
    gclid: sanitize(formData.gclid),
    gbraid: sanitize(formData.gbraid),
    wbraid: sanitize(formData.wbraid),
  };

  return emailjs.send(SERVICE_ID, OzempicLawsuit_ADMIN_TEMPLATE_ID, templateParams);
};
export const OzempicLawsuitSendAdminEmailE = async ({ formData }) => {
  const ipAddress = await getIPAddress();

  const docs = Array.isArray(formData.documentUrls)
    ? formData.documentUrls
    : [];

  const templateParams = {
    submissionDate: new Date().toLocaleString(),
    submissionDateCST: getCSTTimestamp(),
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,

    fullName: sanitize(formData.fullName),
    email: sanitize(formData.email),
    phone: sanitize(formData.phone),

    q1: sanitize(formData.q1),
    q2: sanitize(formData.q2),
    q3: sanitize(formData.q3),

    certId: sanitize(formData.certId),
    pingUrl: sanitize(formData.pingUrl),
    tokenUrl: sanitize(formData.tokenUrl),

    ip_address: ipAddress,
    page_source: getSourceUrl(),

    gclid: sanitize(formData.gclid),
    gbraid: sanitize(formData.gbraid),
    wbraid: sanitize(formData.wbraid),

    /* DOCUMENT LINKS */

    doc1: docs[0] || "",
    doc2: docs[1] || "",
    doc3: docs[2] || "",
    doc4: docs[3] || "",
    doc5: docs[4] || "",
    doc6: docs[5] || "",
    doc7: docs[6] || "",
    doc8: docs[7] || "",
    doc9: docs[8] || "",
    doc10: docs[9] || "",
  };

  return emailjs.send(
    SERVICE_ID,
    OzempicLawsuitE_ADMIN_TEMPLATE_ID,
    templateParams
  );
};
export const OzempicLawsuitSendUserEmail = async ({ formData }) => {
  const templateParams = {
    submissionDate: new Date().toLocaleString(),
submissionDateCST: getCSTTimestamp(),
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,

    fullName: sanitize(formData.fullName),
    email: sanitize(formData.email),
    phone: sanitize(formData.phone),

    // Include questions for confirmation
    q1: sanitize(formData.q1),
    q2: sanitize(formData.q2),
    q3: sanitize(formData.q3),

    date: new Date().toLocaleDateString(),
    form_type: 'Ozempic Lawsuit Landing Page'
  };

  return emailjs.send(SERVICE_ID, OzempicLawsuit_USER_TEMPLATE_ID, templateParams);
};

//talcum lander form functions A
export const TalcumPowderLawsuitSendAdminEmail = async ({ formData }) => {
  const ipAddress = await getIPAddress();

  const templateParams = {
    submissionDate: new Date().toLocaleString(),
submissionDateCST: getCSTTimestamp(),
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,

    fullName: sanitize(formData.fullName),
    email: sanitize(formData.email),
    phone: sanitize(formData.phone),

    // 3-question lawsuit lander questions
    q1: sanitize(formData.q1), // Dropdown: "Which condition were you diagnosed with?"
    q2: sanitize(formData.q2), // "Did you use talcum powder in the genital or perineal area?"
    q3: sanitize(formData.q3), // "Are you currently working with an attorney?"

    message: `New Talcum Powder Lawsuit inquiry from ${sanitize(formData.fullName)}`,

    certId: sanitize(formData.certId),
    pingUrl: sanitize(formData.pingUrl),
    tokenUrl: sanitize(formData.tokenUrl),

    ip_address: ipAddress,
    page_source: getSourceUrl(),
    form_type: 'Talcum Powder Lawsuit Landing Page',

    // Ad tracking
    gclid: sanitize(formData.gclid),
    gbraid: sanitize(formData.gbraid),
    wbraid: sanitize(formData.wbraid),
  };

  return emailjs.send(SERVICE_ID, TalcumPowderLawsuit_ADMIN_TEMPLATE_ID, templateParams);
};

export const TalcumPowderLawsuitSendUserEmail = async ({ formData }) => {
  const templateParams = {
    submissionDate: new Date().toLocaleString(),
submissionDateCST: getCSTTimestamp(),
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,

    fullName: sanitize(formData.fullName),
    email: sanitize(formData.email),
    phone: sanitize(formData.phone),

    // Include questions for confirmation
    q1: sanitize(formData.q1),
    q2: sanitize(formData.q2),
    q3: sanitize(formData.q3),

    date: new Date().toLocaleDateString(),
    form_type: 'Talcum Powder Lawsuit Landing Page'
  };

  return emailjs.send(SERVICE_ID, TalcumPowderLawsuit_USER_TEMPLATE_ID, templateParams);
};

//RideshareSA lander form functions A
export const RideshareSALawsuitSendAdminEmail = async ({ formData }) => {
  const ipAddress = await getIPAddress();

  const templateParams = {
    submissionDate: new Date().toLocaleString(),
submissionDateCST: getCSTTimestamp(),
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,

    fullName: sanitize(formData.fullName),
    email: sanitize(formData.email),
    phone: sanitize(formData.phone),

    // 3-question rideshare SA lander
    q1: sanitize(formData.q1), // Incident type
    q2: sanitize(formData.q2), // Was offender Uber/Lyft driver?
    q3: sanitize(formData.q3), // Already has attorney?

    message: `New Rideshare Sexual Assault inquiry from ${sanitize(formData.fullName)}`,

    // TrustedForm
    certId: sanitize(formData.certId),
    pingUrl: sanitize(formData.pingUrl),
    tokenUrl: sanitize(formData.tokenUrl),

    // Metadata
    ip_address: ipAddress,
    page_source: getSourceUrl(),
    form_type: 'Rideshare Sexual Assault Lawsuit Landing Page',

    // Ad tracking
    gclid: sanitize(formData.gclid),
    gbraid: sanitize(formData.gbraid),
    wbraid: sanitize(formData.wbraid),
  };

  return emailjs.send(
    SERVICE_ID,
    RideshareSALawsuit_ADMIN_TEMPLATE_ID,
    templateParams
  );
};

export const RideshareSALawsuitSendUserEmail = async ({ formData }) => {
  const templateParams = {
    submissionDate: new Date().toLocaleString(),
submissionDateCST: getCSTTimestamp(),
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,

    fullName: sanitize(formData.fullName),
    email: sanitize(formData.email),
    phone: sanitize(formData.phone),

    // Echo answers for confirmation
    q1: sanitize(formData.q1),
    q2: sanitize(formData.q2),
    q3: sanitize(formData.q3),

    date: new Date().toLocaleDateString(),
    form_type: 'Rideshare Sexual Assault Lawsuit Landing Page',
  };

  return emailjs.send(
    SERVICE_ID,
    RideshareSALawsuit_USER_TEMPLATE_ID,
    templateParams
  );
};

//Social media addiction lander form functions A
export const SMALawsuitSendAdminEmail = async ({ formData }) => {
  const ipAddress = await getIPAddress();

  const templateParams = {
    submissionDate: new Date().toLocaleString(),
submissionDateCST: getCSTTimestamp(),
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,

    fullName: sanitize(formData.fullName),
    email: sanitize(formData.email),
    phone: sanitize(formData.phone),

    // 3-question Social Media Addiction lander
    q1: sanitize(formData.q1), // Currently under 19?
    q2: sanitize(formData.q2), // Used social media before 18?
    q3: sanitize(formData.q3), // Serious harm after use?

    message: `New Social Media Addiction inquiry from ${sanitize(formData.fullName)}`,

    // TrustedForm
    certId: sanitize(formData.certId),
    pingUrl: sanitize(formData.pingUrl),
    tokenUrl: sanitize(formData.tokenUrl),

    // Metadata
    ip_address: ipAddress,
    page_source: getSourceUrl(),
    form_type: 'Social Media Addiction Lawsuit Landing Page',

    // Ad tracking
    gclid: sanitize(formData.gclid),
    gbraid: sanitize(formData.gbraid),
    wbraid: sanitize(formData.wbraid),
  };

  return emailjs.send(
    SERVICE_ID,
    SMALawsuit_ADMIN_TEMPLATE_ID,
    templateParams
  );
};

export const SMALawsuitSendUserEmail = async ({ formData }) => {
  const templateParams = {
    submissionDate: new Date().toLocaleString(),
submissionDateCST: getCSTTimestamp(),
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,

    fullName: sanitize(formData.fullName),
    email: sanitize(formData.email),
    phone: sanitize(formData.phone),

    // Echo answers for confirmation
    q1: sanitize(formData.q1),
    q2: sanitize(formData.q2),
    q3: sanitize(formData.q3),

    date: new Date().toLocaleDateString(),
    form_type: 'Social Media Addiction Lawsuit Landing Page',
  };

  return emailjs.send(
    SERVICE_ID,
    SMALawsuit_USER_TEMPLATE_ID,
    templateParams
  );
};


//RobloxSA lander form functions A
export const RobloxSALawsuitSendAdminEmail = async ({ formData }) => {
  const ipAddress = await getIPAddress();

  const templateParams = {
    submissionDate: new Date().toLocaleString(),
submissionDateCST: getCSTTimestamp(),
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,

    fullName: sanitize(formData.fullName),
    email: sanitize(formData.email),
    phone: sanitize(formData.phone),

    // 3-question Roblox SA lander
    q1: sanitize(formData.q1), // Met abuser through Roblox?
    q2: sanitize(formData.q2), // Under 18 at time of abuse?
    q3: sanitize(formData.q3), // Sexual exploitation / harm occurred?

    message: `New Roblox Sexual Abuse inquiry from ${sanitize(formData.fullName)}`,

    // TrustedForm
    certId: sanitize(formData.certId),
    pingUrl: sanitize(formData.pingUrl),
    tokenUrl: sanitize(formData.tokenUrl),

    // Metadata
    ip_address: ipAddress,
    page_source: getSourceUrl(),
    form_type: 'Roblox Sexual Abuse Lawsuit Landing Page',

    // Ad tracking
    gclid: sanitize(formData.gclid),
    gbraid: sanitize(formData.gbraid),
    wbraid: sanitize(formData.wbraid),
  };

  return emailjs.send(
    SERVICE_ID,
    RobloxSALawsuit_ADMIN_TEMPLATE_ID,
    templateParams
  );
};

export const RobloxSALawsuitSendUserEmail = async ({ formData }) => {
  const templateParams = {
    submissionDate: new Date().toLocaleString(),
submissionDateCST: getCSTTimestamp(),
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,

    fullName: sanitize(formData.fullName),
    email: sanitize(formData.email),
    phone: sanitize(formData.phone),

    // Echo answers for confirmation
    q1: sanitize(formData.q1),
    q2: sanitize(formData.q2),
    q3: sanitize(formData.q3),

    date: new Date().toLocaleDateString(),
    form_type: 'Roblox Sexual Abuse Lawsuit Landing Page',
  };

  return emailjs.send(
    SERVICE_ID,
    RobloxSALawsuit_USER_TEMPLATE_ID,
    templateParams
  );
};


//Roundup lawsuit lander form functions A
export const RoundupLawsuitSendAdminEmail = async ({ formData }) => {
  const ipAddress = await getIPAddress();

  const templateParams = {
    submissionDate: new Date().toLocaleString(),
submissionDateCST: getCSTTimestamp(),
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,

    fullName: sanitize(formData.fullName),
    email: sanitize(formData.email),
    phone: sanitize(formData.phone),

    // 3-question Roundup Lawsuit lander
    q1: sanitize(formData.q1), // Diagnosed with Non-Hodgkin's Lymphoma?
    q2: sanitize(formData.q2), // Used Roundup for 3+ years before diagnosis?
    q3: sanitize(formData.q3), // Currently represented by an attorney?

    message: `New Roundup Lawsuit inquiry from ${sanitize(formData.fullName)}`,

    // TrustedForm
    certId: sanitize(formData.certId),
    pingUrl: sanitize(formData.pingUrl),
    tokenUrl: sanitize(formData.tokenUrl),

    // Metadata
    ip_address: ipAddress,
    page_source: getSourceUrl(),
    form_type: 'Roundup Lawsuit Landing Page',

    // Ad tracking
    gclid: sanitize(formData.gclid),
    gbraid: sanitize(formData.gbraid),
    wbraid: sanitize(formData.wbraid),
  };

  return emailjs.send(
    SERVICE_ID,
    ROUNDUP_LAWSUIT_ADMIN_TEMPLATE_ID,
    templateParams
  );
};

export const RoundupLawsuitSendUserEmail = async ({ formData }) => {
  const templateParams = {
    submissionDate: new Date().toLocaleString(),
submissionDateCST: getCSTTimestamp(),
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,

    fullName: sanitize(formData.fullName),
    email: sanitize(formData.email),
    phone: sanitize(formData.phone),

    // Echo answers for confirmation
    q1: sanitize(formData.q1),
    q2: sanitize(formData.q2),
    q3: sanitize(formData.q3),

    date: new Date().toLocaleDateString(),
    form_type: 'Roundup Lawsuit Landing Page',
  };

  return emailjs.send(
    SERVICE_ID,
    ROUNDUP_LAWSUIT_USER_TEMPLATE_ID,
    templateParams
  );
};


//Dupixent lawsuit lander form functions D
export const DupixentLawsuitSendAdminEmail = async ({ formData }) => {
  const ipAddress = await getIPAddress();

  const templateParams = {
    submissionDate: new Date().toLocaleString(),
submissionDateCST: getCSTTimestamp(),
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,

    fullName: sanitize(formData.fullName),
    email: sanitize(formData.email),
    phone: sanitize(formData.phone),

    // Dupixent questions
    q1: sanitize(formData.q1), // Diagnosed with CTCL?
    q2: sanitize(formData.q2), // Diagnosis after Dupixent?
    q3: sanitize(formData.q3), // Attorney?

    message: `New Dupixent Lawsuit inquiry from ${sanitize(formData.fullName)}`,

    // TrustedForm
    certId: sanitize(formData.certId),
    pingUrl: sanitize(formData.pingUrl),
    tokenUrl: sanitize(formData.tokenUrl),

    // Metadata
    ip_address: ipAddress,
    page_source: getSourceUrl(),
    form_type: 'Dupixent Lawsuit Landing Page',

    // Ad tracking
    gclid: sanitize(formData.gclid),
    gbraid: sanitize(formData.gbraid),
    wbraid: sanitize(formData.wbraid),
  };

  return emailjs.send(
    SERVICE_ID,
    DupixentLawsuit_ADMIN_TEMPLATE_ID,
    templateParams
  );
};

export const DupixentLawsuitSendUserEmail = async ({ formData }) => {
  const templateParams = {
    submissionDate: new Date().toLocaleString(),
submissionDateCST: getCSTTimestamp(),
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,

    fullName: sanitize(formData.fullName),
    email: sanitize(formData.email),
    phone: sanitize(formData.phone),

    // Echo answers
    q1: sanitize(formData.q1),
    q2: sanitize(formData.q2),
    q3: sanitize(formData.q3),

    date: new Date().toLocaleDateString(),
    form_type: 'Dupixent Lawsuit Landing Page',
  };

  return emailjs.send(
    SERVICE_ID,
    DupixentLawsuit_USER_TEMPLATE_ID,
    templateParams
  );
};











// Talcum Powder form functions
export const TalcumPowderSendAdminEmail = async ({ formData }) => {
  const ipAddress = await getIPAddress();

  const templateParams = {
    submissionDate: new Date().toLocaleString(),
submissionDateCST: getCSTTimestamp(),
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,

    FirstName: sanitize(formData.FirstName),
    LastName: sanitize(formData.LastName),
    fullName: `${sanitize(formData.FirstName)} ${sanitize(formData.LastName)}`.trim(),
    email: sanitize(formData.email),
    phoneNumber: sanitize(formData.phoneNumber),
    state: sanitize(formData.state),

    // Talcum Powder Questions
    q1: sanitize(formData['Are you female?']),
    q2: sanitize(
      formData['Were you diagnosed with ovarian cancer or fallopian tube cancer in 2015 or later?']
    ),
    q3: sanitize(
      formData["Did you regularly use Johnson's Baby Powder or Johnson & Johnson's Shower to Shower for personal hygiene ?"]
    ),
    q4: sanitize(formData['Did your use occur after 1982?']),
    q5: sanitize(
      formData["For how long did you use Johnson's Baby Powder or Shower to Shower for personal hygiene?"]
    ),
    q6: sanitize(formData['Are you currently represented by an attorney for this case?']),

    message: `New Talcum Powder eligibility check from ${sanitize(
      formData.FirstName
    )} ${sanitize(formData.LastName)}`,

    trustedFormCertUrl: formData.certId || 'Not available',
    trustedFormPingUrl: formData.pingUrl || 'Not available',
    trustedFormToken: formData.tokenUrl || 'Not available',

    ip_address: ipAddress,
    page_source: getSourceUrl(),
    form_type: 'Talcum Powder Lawsuit Eligibility Check'
  };

  return emailjs.send(
    SERVICE_ID,
    TalcumPowder_ADMIN_TEMPLATE_ID,
    templateParams
  );
};

export const TalcumPowderSendUserEmail = async ({ formData }) => {
  const templateParams = {
    submissionDate: new Date().toLocaleString(),
submissionDateCST: getCSTTimestamp(),
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,

    FirstName: sanitize(formData.FirstName),
    LastName: sanitize(formData.LastName),
    fullName: `${sanitize(formData.FirstName)} ${sanitize(formData.LastName)}`.trim(),
    email: sanitize(formData.email),
    phoneNumber: sanitize(formData.phoneNumber),
    state: sanitize(formData.state),

    // Optional: include answers if needed later
    q1: sanitize(formData['Are you female?']),
    q2: sanitize(
      formData['Were you diagnosed with ovarian cancer or fallopian tube cancer in 2015 or later?']
    ),
    q3: sanitize(
      formData["Did you regularly use Johnson's Baby Powder or Johnson & Johnson's Shower to Shower for personal hygiene ?"]
    ),
    q4: sanitize(formData['Did your use occur after 1982?']),
    q5: sanitize(
      formData["For how long did you use Johnson's Baby Powder or Shower to Shower for personal hygiene?"]
    ),
    q6: sanitize(formData['Are you currently represented by an attorney for this case?']),

    date: new Date().toLocaleDateString(),
    form_type: 'Talcum Powder Lawsuit Eligibility Check'
  };

  return emailjs.send(
    SERVICE_ID,
    TalcumPowder_USER_TEMPLATE_ID,
    templateParams
  );
};


// Depo Provera form functions
export const DepoProveraSendAdminEmail = async ({ formData }) => {
  const ipAddress = await getIPAddress();

  const templateParams = {
    submissionDate: new Date().toLocaleString(),
submissionDateCST: getCSTTimestamp(),
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,

    FirstName: sanitize(formData.FirstName),
    LastName: sanitize(formData.LastName),
    fullName: `${sanitize(formData.FirstName)} ${sanitize(formData.LastName)}`.trim(),
    email: sanitize(formData.email),
    phoneNumber: sanitize(formData.phoneNumber),
    state: sanitize(formData.state),

    q1: sanitize(formData['Are you female?']),
    q2: sanitize(formData['Did you receive Depo-Provera (birth control injection)?']),
    q3: sanitize(formData['Have you been diagnosed with a brain tumor, including meningioma?']),
    q4: sanitize(formData['How old were you at the time of your brain tumor diagnosis?']),
    q5: sanitize(formData['For how long did you receive Depo-Provera injections?']),
    q6: sanitize(formData['Did your brain tumor diagnosis occur within the last 10 years?']),
    q7: sanitize(formData['Is the person diagnosed still living?']),
    q8: sanitize(formData['Did the person pass away within the last 10 years?']),
    q9: sanitize(formData['Do you have access to medical records related to the brain tumor diagnosis?']),
    q10: sanitize(formData['Are you currently represented by an attorney for this case?']),

    message: `New Depo-Provera Brain Tumor eligibility check from ${sanitize(formData.FirstName)} ${sanitize(formData.LastName)}`,

    trustedFormCertUrl: formData.certId || 'Not available',
    trustedFormPingUrl: formData.pingUrl || 'Not available',
    trustedFormToken: formData.tokenUrl || 'Not available',

    ip_address: ipAddress,
    page_source: getSourceUrl(),
    form_type: 'Depo-Provera Brain Tumor Eligibility Check'
  };

  return emailjs.send(SERVICE_ID, DepoProvera_ADMIN_TEMPLATE_ID, templateParams);
};


export const DepoProveraSendUserEmail = async ({ formData }) => {
  const templateParams = {
    submissionDate: new Date().toLocaleString(),
submissionDateCST: getCSTTimestamp(),
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,

    FirstName: sanitize(formData.FirstName),
    LastName: sanitize(formData.LastName),
    fullName: `${sanitize(formData.FirstName)} ${sanitize(formData.LastName)}`.trim(),
    email: sanitize(formData.email),
    phoneNumber: sanitize(formData.phoneNumber),
    state: sanitize(formData.state),

    q1: sanitize(formData['Are you female?']),
    q2: sanitize(formData['Did you receive Depo-Provera (birth control injection)?']),
    q3: sanitize(formData['Have you been diagnosed with a brain tumor, including meningioma?']),
    q4: sanitize(formData['How old were you at the time of your brain tumor diagnosis?']),
    q5: sanitize(formData['For how long did you receive Depo-Provera injections?']),
    q6: sanitize(formData['Did your brain tumor diagnosis occur within the last 10 years?']),
    q7: sanitize(formData['Is the person diagnosed still living?']),
    q8: sanitize(formData['Did the person pass away within the last 10 years?']),
    q9: sanitize(formData['Do you have access to medical records related to the brain tumor diagnosis?']),
    q10: sanitize(formData['Are you currently represented by an attorney for this case?']),

    date: new Date().toLocaleDateString(),
    form_type: 'Depo-Provera Brain Tumor Eligibility Check'
  };

  return emailjs.send(SERVICE_ID, DepoProvera_USER_TEMPLATE_ID, templateParams);
};

//Hair Relaxer form functions
export const HairRelaxerSendAdminEmail = async ({ formData }) => {
  const ipAddress = await getIPAddress();

  const templateParams = {
    submissionDate: new Date().toLocaleString(),
submissionDateCST: getCSTTimestamp(),
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,

    FirstName: sanitize(formData.FirstName),
    LastName: sanitize(formData.LastName),
    fullName: `${sanitize(formData.FirstName)} ${sanitize(formData.LastName)}`.trim(),
    email: sanitize(formData.email),
    phoneNumber: sanitize(formData.phoneNumber),
    state: sanitize(formData.state),

    // Hair Relaxer Questions
    q1: sanitize(formData['Have you been diagnosed with any of the following cancers in 2010 or later?']),
    q2: sanitize(formData['How old were you at the time of your cancer diagnosis?']),
    q3: sanitize(formData['Did you use chemical hair relaxer products continuously for at least 4 years before your diagnosis?']),
    q4: sanitize(formData['During your highest period of use, did you use hair relaxers at least 4 times per year?']),
    q5: sanitize(formData['Did your cancer diagnosis occur within 10 years of your last hair relaxer use?']),
    q6: sanitize(formData['Do you know the hair relaxer brand you used, and did it contain formaldehyde or phthalates?']),
    q7: sanitize(formData['Are you currently represented by an attorney for this case?']),

    message: `New Hair Relaxer Cancer eligibility check from ${sanitize(formData.FirstName)} ${sanitize(formData.LastName)}`,

    trustedFormCertUrl: formData.certId || 'Not available',
    trustedFormPingUrl: formData.pingUrl || 'Not available',
    trustedFormToken: formData.tokenUrl || 'Not available',

    ip_address: ipAddress,
    page_source: getSourceUrl(),
    form_type: 'Hair Relaxer Cancer Eligibility Check'
  };

  return emailjs.send(
    SERVICE_ID,
    HairRelaxer_ADMIN_TEMPLATE_ID,
    templateParams
  );
};

export const HairRelaxerSendUserEmail = async ({ formData }) => {
  const templateParams = {
    submissionDate: new Date().toLocaleString(),
submissionDateCST: getCSTTimestamp(),
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,

    FirstName: sanitize(formData.FirstName),
    LastName: sanitize(formData.LastName),
    fullName: `${sanitize(formData.FirstName)} ${sanitize(formData.LastName)}`.trim(),
    email: sanitize(formData.email),
    phoneNumber: sanitize(formData.phoneNumber),
    state: sanitize(formData.state),

    // Hair Relaxer Questions (optional for user template, but safe to include)
    q1: sanitize(formData['Have you been diagnosed with any of the following cancers in 2010 or later?']),
    q2: sanitize(formData['How old were you at the time of your cancer diagnosis?']),
    q3: sanitize(formData['Did you use chemical hair relaxer products continuously for at least 4 years before your diagnosis?']),
    q4: sanitize(formData['During your highest period of use, did you use hair relaxers at least 4 times per year?']),
    q5: sanitize(formData['Did your cancer diagnosis occur within 10 years of your last hair relaxer use?']),
    q6: sanitize(formData['Do you know the hair relaxer brand you used, and did it contain formaldehyde or phthalates?']),
    q7: sanitize(formData['Are you currently represented by an attorney for this case?']),

    date: new Date().toLocaleDateString(),
    form_type: 'Hair Relaxer Cancer Eligibility Check'
  };

  return emailjs.send(
    SERVICE_ID,
    HairRelaxer_USER_TEMPLATE_ID,
    templateParams
  );
};

// Ozempic form functions
export const OzempicSendAdminEmail = async ({ formData }) => {
  const ipAddress = await getIPAddress();

  const templateParams = {
    submissionDate: new Date().toLocaleString(),
submissionDateCST: getCSTTimestamp(),
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,

    FirstName: sanitize(formData.FirstName),
    LastName: sanitize(formData.LastName),
    fullName: `${sanitize(formData.FirstName)} ${sanitize(formData.LastName)}`.trim(),
    email: sanitize(formData.email),
    phoneNumber: sanitize(formData.phoneNumber),
    state: sanitize(formData.state),

    // Ozempic / GLP-1 Vision Loss Questions
    q1: sanitize(
      formData[
        'Have you been diagnosed with Non-Arteritic Anterior Ischemic Optic Neuropathy (NAION)?'
      ]
    ),
    q2: sanitize(
      formData[
        'Did your NAION diagnosis occur while you were actively taking the medication?'
      ]
    ),
    q3: sanitize(
      formData[
        'Did you stop taking the medication at the time of your NAION diagnosis?'
      ]
    ),
    q4: sanitize(
      formData[
        'Do you currently have permanent vision impairment as a result of NAION?'
      ]
    ),
    q5: sanitize(
      formData[
        'How old are you right now?'
      ]
    ),
    q6: sanitize(
      formData[
        'Did you use a brand-name GLP-1 medication such as one of the following?'
      ]
    ),
    q7: sanitize(
      formData[
        'Are you currently represented by an attorney for this matter?'
      ]
    ),

    message: `New Ozempic / GLP-1 Vision Loss eligibility check from ${sanitize(
      formData.FirstName
    )} ${sanitize(formData.LastName)}`,

    trustedFormCertUrl: formData.certId || 'Not available',
    trustedFormPingUrl: formData.pingUrl || 'Not available',
    trustedFormToken: formData.tokenUrl || 'Not available',

    ip_address: ipAddress,
    page_source: getSourceUrl(),
    form_type: 'Ozempic & GLP-1 Vision Loss (NAION) Eligibility Check'
  };

  return emailjs.send(
    SERVICE_ID,
    Ozempic_ADMIN_TEMPLATE_ID,
    templateParams
  );
};

export const OzempicSendUserEmail = async ({ formData }) => {
  const templateParams = {
    submissionDate: new Date().toLocaleString(),
submissionDateCST: getCSTTimestamp(),
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,

    FirstName: sanitize(formData.FirstName),
    LastName: sanitize(formData.LastName),
    fullName: `${sanitize(formData.FirstName)} ${sanitize(formData.LastName)}`.trim(),
    email: sanitize(formData.email),
    phoneNumber: sanitize(formData.phoneNumber),
    state: sanitize(formData.state),

    // Ozempic Questions (optional for user email)
    q1: sanitize(
      formData[
        'Have you been diagnosed with Non-Arteritic Anterior Ischemic Optic Neuropathy (NAION)?'
      ]
    ),
    q2: sanitize(
      formData[
        'Did your NAION diagnosis occur while you were actively taking the medication?'
      ]
    ),
    q3: sanitize(
      formData[
        'Did you stop taking the medication at the time of your NAION diagnosis?'
      ]
    ),
    q4: sanitize(
      formData[
        'Do you currently have permanent vision impairment as a result of NAION?'
      ]
    ),
    q5: sanitize(
      formData[
        'How old are you right now?'
      ]
    ),
    q6: sanitize(
      formData[
        'Did you use a brand-name GLP-1 medication such as one of the following?'
      ]
    ),
    q7: sanitize(
      formData[
        'Are you currently represented by an attorney for this matter?'
      ]
    ),

    date: new Date().toLocaleDateString(),
    form_type: 'Ozempic & GLP-1 Vision Loss (NAION) Eligibility Check'
  };

  return emailjs.send(
    SERVICE_ID,
    Ozempic_USER_TEMPLATE_ID,
    templateParams
  );
};


// Hernia Mesh form functions
export const HerniaMeshSendAdminEmail = async ({ formData }) => {
  const ipAddress = await getIPAddress();

  const templateParams = {
    submissionDate: new Date().toLocaleString(),
submissionDateCST: getCSTTimestamp(),
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,

    FirstName: sanitize(formData.FirstName),
    LastName: sanitize(formData.LastName),
    fullName: `${sanitize(formData.FirstName)} ${sanitize(formData.LastName)}`.trim(),
    email: sanitize(formData.email),
    phoneNumber: sanitize(formData.phoneNumber),
    state: sanitize(formData.state),

    // Hernia Mesh Eligibility Questions (DOC-ALIGNED)
    q1: sanitize(
      formData[
        'Did you receive a hernia mesh implant as part of a hernia repair surgery?'
      ]
    ),
    q2: sanitize(
      formData[
        'What complication did you experience after your hernia mesh surgery?'
      ]
    ),
    q3: sanitize(
      formData[
        'Did you require revision or removal surgery due to the complication?'
      ]
    ),
    q4: sanitize(
      formData[
        'How old were you when the mesh complication occurred?'
      ]
    ),
    q5: sanitize(
      formData[
        'Did the complication or revision surgery occur within the last 10 years?'
      ]
    ),
    q6: sanitize(
      formData[
        'Are you currently represented by an attorney for this matter?'
      ]
    ),
    q7: sanitize(
      formData[
        'Do you have access to medical records related to your hernia mesh surgery or complications?'
      ]
    ),

    message: `New Hernia Mesh eligibility check from ${sanitize(
      formData.FirstName
    )} ${sanitize(formData.LastName)}`,

    trustedFormCertUrl: formData.certId || 'Not available',
    trustedFormPingUrl: formData.pingUrl || 'Not available',
    trustedFormToken: formData.tokenUrl || 'Not available',

    ip_address: ipAddress,
    page_source: getSourceUrl(),
    form_type: 'Hernia Mesh Lawsuit Eligibility Check'
  };

  return emailjs.send(
    SERVICE_ID,
    HerniaMesh_ADMIN_TEMPLATE_ID,
    templateParams
  );
};


export const HerniaMeshSendUserEmail = async ({ formData }) => {
  const templateParams = {
    submissionDate: new Date().toLocaleString(),
submissionDateCST: getCSTTimestamp(),
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,

    FirstName: sanitize(formData.FirstName),
    LastName: sanitize(formData.LastName),
    fullName: `${sanitize(formData.FirstName)} ${sanitize(formData.LastName)}`.trim(),
    email: sanitize(formData.email),
    phoneNumber: sanitize(formData.phoneNumber),
    state: sanitize(formData.state),

    // Hernia Mesh Questions (optional display for user)
    q1: sanitize(
      formData[
        'Did you receive a hernia mesh implant as part of a hernia repair surgery?'
      ]
    ),
    q2: sanitize(
      formData[
        'What complication did you experience after your hernia mesh surgery?'
      ]
    ),
    q3: sanitize(
      formData[
        'Did you require revision or removal surgery due to the complication?'
      ]
    ),
    q4: sanitize(
      formData[
        'How old were you when the mesh complication occurred?'
      ]
    ),
    q5: sanitize(
      formData[
        'Did the complication or revision surgery occur within the last 10 years?'
      ]
    ),
    q6: sanitize(
      formData[
        'Are you currently represented by an attorney for this matter?'
      ]
    ),
    q7: sanitize(
      formData[
        'Do you have access to medical records related to your hernia mesh surgery or complications?'
      ]
    ),

    date: new Date().toLocaleDateString(),
    form_type: 'Hernia Mesh Lawsuit Eligibility Check'
  };

  return emailjs.send(
    SERVICE_ID,
    HerniaMesh_USER_TEMPLATE_ID,
    templateParams
  );
};



// Lead Prosper API function for Depo-Provera
// export const sendToLeadProsper = async ({formData}) => {
//   try {
//     const ipAddress = await getIPAddress();
    
//     // Map form data to Lead Prosper API format
//     const leadProsperData = {
//       lp_campaign_id: "30996",
//       lp_supplier_id: "96284",
//       lp_key: "goda5jnrux65q",
//       lp_action: "",
//       lp_subid1: "",
//       lp_subid2: "",
//       Source: "ConnectWithLawyers",
//       first_name: sanitize(formData.FirstName) || "",
//       last_name: sanitize(formData.LastName) || "",
//       email: sanitize(formData.email) || "",
//       number1: cleanPhoneNumber(formData.phoneNumber) || "",
//       street: "",
//       city: "",
//       zip: "",
//       state: sanitize(formData.state) || "",
//       other_cancer_type: "",
//       diagnosis_date: "",
//       Diagnosed_in_the_last_4_years: "",
//       Used_product_12_months_or_more_before_dx: "",
//       Does_the_Injured_Party_Have_an_Attorney: sanitize(formData['Are you currently represented by an attorney for this case?']) || "",
//       date_of_birth: "",
//       notes: "",
//       external_id: "",
//       ip_adress: ipAddress,
//       verification_id_2: "",
//       verification_id: formData.certId || "",
//       Visit_Date: new Date().toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' })
//     };

//     const response = await fetch('https://api.leadprosper.io/direct_post', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//       },
//       body: JSON.stringify(leadProsperData)
//     });

//     const result = await response.json();
//     console.log('Lead Prosper API Response:', result);
//     return result;
//   } catch (error) {
//     // Log error but don't throw - we want to continue with email calls even if this fails
//     console.error('Failed to send to Lead Prosper API:', error);
//     return { status: 'ERROR', message: error.message };
//   }
// };

// ClaimFormInline (Car Accident Claim Form) functions
const CLAIM_FORM_ADMIN_TEMPLATE_ID = 'template_fr4evoh';
const CLAIM_FORM_USER_TEMPLATE_ID = 'template_2yh7dud';

export const ClaimFormSendAdminEmail = async (formData, trustedFormData = {}) => {
  const ipAddress = await getIPAddress();

  const templateParams = {
    name: sanitize(formData.name),
    email: sanitize(formData.email),
    phone: sanitize(formData.phone),
    involved: sanitize(formData.involved),
    injured: sanitize(formData.injured),
    fault: sanitize(formData.fault),
    attorney: sanitize(formData.attorney),
    period: sanitize(formData.period),
    submissionDate: new Date().toLocaleString(),
submissionDateCST: getCSTTimestamp(),
    ip_address: ipAddress,
    page_source: getSourceUrl(),
    trustedFormCertUrl: trustedFormData.xxTrustedFormCertUrl || trustedFormData.certId || 'Not available',
    trustedFormPingUrl: trustedFormData.xxTrustedFormPingUrl || trustedFormData.pingUrl || 'Not available',
    trustedFormToken: trustedFormData.xxTrustedFormCertToken || trustedFormData.tokenUrl || 'Not available',
  };

  return emailjs.send(SERVICE_ID, CLAIM_FORM_ADMIN_TEMPLATE_ID, templateParams);
};

export const ClaimFormSendUserEmail = async (formData) => {
  const templateParams = {
    name: sanitize(formData.name),
    email: sanitize(formData.email),
    phone: sanitize(formData.phone),
    submissionDate: new Date().toLocaleString(),
submissionDateCST: getCSTTimestamp(),
  };

  return emailjs.send(SERVICE_ID, CLAIM_FORM_USER_TEMPLATE_ID, templateParams);
};

// Combined function that sends admin first, then user if admin succeeds
export const ClaimFormSendEmails = async (formData, trustedFormData = {}) => {
  try {
    // First, send admin email
    const adminResponse = await ClaimFormSendAdminEmail(formData, trustedFormData);
    
    // Only if admin email succeeds, send user email
    if (adminResponse && adminResponse.status === 200) {
      const userResponse = await ClaimFormSendUserEmail(formData);
      return { 
        success: true, 
        adminResponse, 
        userResponse 
      };
    } else {
      throw new Error('Admin email failed');
    }
  } catch (error) {
    console.error('Failed to send emails:', error);
    return { 
      success: false, 
      error: error.message || 'Failed to send emails' 
    };
  }
};

